const SET_POPUP = {
  init(popupOffsets, HTMLContent) {
    return new mapboxgl.Popup({ offset: popupOffsets }).setHTML(HTMLContent)
  }
}

export default SET_POPUP;
